var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import environment from '@square/environment-utils/environment';
import fetch from 'fetch';
import { FlagNames } from './ember-multipass-flag';
import { createUUID } from '../utils/create-uuid';
export const CONFIG = Object.freeze({
  BARE_DOMAIN: {
    STAGING: 'squareupstaging.com',
    SANDBOX: 'squareupsandbox.com',
    PRODUCTION: 'squareup.com'
  },
  BARE_APP_DOMAIN: {
    STAGING: 'app.squareupstaging.com',
    SANDBOX: 'app.squareupsandbox.com',
    PRODUCTION: 'app.squareup.com'
  },
  BARE_APP_URI: {
    STAGING: 'https://app.squareupstaging.com',
    SANDBOX: 'https://app.squareupsandbox.com',
    PRODUCTION: 'https://app.squareup.com'
  },
  BARE_URI: {
    STAGING: 'https://squareupstaging.com',
    SANDBOX: 'https://squareupsandbox.com',
    PRODUCTION: 'https://squareup.com'
  },
  CASH_APP_URI: {
    STAGING: 'https://cashstaging.app',
    SANDBOX: 'https://cashstaging.app',
    PRODUCTION: 'https://cash.app'
  },
  CONSTANTS: {
    DEVICE_TRUSTED: 'TRUSTED',
    RECAPTCHA_ENTERPRISE_V2_CHECKBOX: 'RECAPTCHA_ENTERPRISE_V2_CHECKBOX',
    SECURE_CONTACT_ENROLLMENT_SOURCE: {
      TWO_FACTOR_NUMBER: 'TWO_FACTOR_NUMBER',
      USER_PROVIDED: 'USER_PROVIDED'
    },
    SEND_VERIFICATION_CODE_LOGIN: 'LOGIN',
    SEND_VERIFICATION_CODE_RISK_MAGIC_LINK: 'RISK_MAGIC_LINK',
    SEND_VERIFICATION_CODE_SECURE_CONTACT: 'SECURE_CONTACT',
    SEND_VERIFICATION_CODE_TWO_FACTOR: 'TWO_FACTOR',
    SEND_VERIFICATION_CODE_VERIFY: 'VERIFY',
    SMS_RESET_PHONE: '+1 (844) 658-8792',
    // used to opt-in phone numbers that are being returned as blocked
    NOTIFICATION_LOCALE_COOKIE_NAME: 'L',
    LOGIN_OBLIGATIONS: {
      DORMANT_RECOVERY: 'DORMANT_RECOVERY',
      RISK_MAGIC_LINK: 'RISK_MAGIC_LINK'
    },
    PRE_2FA_OBLIGATIONS: ['DORMANT_RECOVERY'],
    POST_2FA_OBLIGATIONS: ['RISK_MAGIC_LINK'],
    RECOVERY_REASON: {
      DORMANT_RECOVERY: 'DORMANT_RECOVERY',
      MANDATORY_2FA: 'MANDATORY_2FA'
    },
    // {@link https://prototype.sqprod.co/#/docs/squareup.multipass.TwoFactorEscalationTimestampScope}
    TWO_FACTOR_ESCALATION_TIMESTAMP: {
      TWO_FACTOR_ENROLL_AVOID_DISRUPTION_2FA_TIMESTAMP: 1,
      LOGIN_TWO_FACTOR_BYPASS_2FA_TIMESTAMP: 2,
      EMAIL_TWO_FACTOR_2FA_TIMESTAMP: 3,
      PASSKEY_BYPASS_2FA_TIMESTAMP: 4
    },
    TWO_FACTOR_PROMO_COHORTS: {
      EXCLUDED: 'EXCLUDED',
      INCLUDED: 'INCLUDED',
      INCLUDED_MANDATORY: 'INCLUDED_MANDATORY'
    },
    TWO_FACTOR_REASONS: {
      DORMANT_RECOVERY: 'DORMANT_RECOVERY',
      MANDATORY: 'MANDATORY'
    },
    TWO_FACTOR_VERIFICATION_SOURCE: {
      LOGIN: 'LOGIN',
      STEP_UP_AUTHENTICATION: 'STEP_UP_AUTHENTICATION',
      CHANGE_2FA_SETTINGS: 'CHANGE_2FA_SETTINGS'
    },
    VERIFY_RECOVERY_DETAIL_METHODS: {
      ACTIVATION_PHONE: 'ACTIVATION_PHONE',
      IDENTITY_VERIFICATION_PHONE: 'IDENTITY_VERIFICATION_PHONE',
      NEW_PHONE: 'NEW_PHONE'
    },
    PHONE_DELIVERY_METHODS: {
      SMS: 'SMS',
      VOICE: 'VOICE'
    },
    MANAGE_PHONE_DETAIL_ACTIONS: {
      BLOCK: 'BLOCK',
      UNBLOCK: 'UNBLOCK'
    },
    COUNTRY_CODES: {
      SMS: ['AU', 'CA', 'ES', 'FR', 'GB', 'IE', 'JP', 'US'],
      VOICE: ['CA', 'US']
    },
    PRIVACY_POLICY_URL: 'https://squareup.com/legal/general/privacy',
    TERMS_AND_CONDITIONS_URL: 'https://squ.re/sms-help',
    SUPPORT_URL: 'https://squareup.com/help/contact?panel=1F8230776D3A'
  },
  ENDPOINTS: {
    // MPFE REST Endpoints
    AUTHZ_ENGINES_ALLOW: `/authz-engines/allow`,
    LOGIN: '/mp/login',
    SELECT_MERCHANT: '/mp/select-merchant',
    STATUS: '/mp/status',
    REDIRECT: '/mp/redirect',
    // MPFE RPC Endpoints
    ACCEPT_INVITATION: '/services/squareup.multipass.external.MultipassExternalService/AcceptInvitation',
    INITIATE_INVITATION: '/services/squareup.multipass.external.MultipassExternalService/InitiateInvitation',
    ADVANCED_ENROLL_TWO_FACTOR_SEND_LINK: `/services/squareup.multipass.external.MultipassExternalService/AdvancedEnrollTwoFactorSendLink`,
    BROWSER_HOOK: `/services/squareup.multipass.external.MultipassExternalService/BrowserHook`,
    CHANGE_ALIAS: `/services/squareup.multipass.frontend.AccountService/ChangeAlias`,
    CHANGE_EMAIL: `/services/squareup.multipass.frontend.AccountService/ChangeEmail`,
    CHANGE_PASSWORD: `/services/squareup.multipass.external.MultipassExternalService/ChangePassword`,
    CHECK_LOGIN_REQUIREMENTS: `/services/squareup.multipass.external.MultipassExternalService/CheckLoginRequirements`,
    CHECK_PASSWORD: `/services/squareup.multipass.external.MultipassExternalService/CheckPassword`,
    CLAIM_ACCOUNT_SEND_CODE: `/services/squareup.multipass.external.MultipassExternalService/ClaimAccountSendCode`,
    CLAIM_ACCOUNT_SET_PASSWORD: `/services/squareup.multipass.external.MultipassExternalService/ClaimAccountSetPassword`,
    COMPLETE_LOGIN: `/services/squareup.multipass.external.MultipassExternalService/CompleteLogin`,
    CREATE_MANDATORY_TWO_FACTOR_EXCEPTION: `/services/squareup.multipass.external.MultipassExternalService/CreateMandatoryTwoFactorException`,
    DEREGISTER_PASSKEY: `/services/squareup.multipass.frontend.AccountService/DeregisterPasskey`,
    ENROLL_SECURE_CONTACT: `/services/squareup.multipass.external.MultipassExternalService/EnrollSecureContact`,
    ENROLL_TWO_FACTOR: `/services/squareup.multipass.external.MultipassExternalService/EnrollTwoFactor`,
    GET_ACCOUNT_INFORMATION: `/services/squareup.multipass.frontend.AccountService/GetAccountInformation`,
    GET_PASSKEY_CHALLENGE: `/services/squareup.multipass.external.MultipassExternalService/GetPasskeyChallenge`,
    GET_TWO_FACTOR_PROMO_COHORT: `/services/squareup.multipass.external.MultipassExternalService/GetTwoFactorPromoCohort`,
    LIST_RECOVERY_DETAILS: `/services/squareup.multipass.external.MultipassExternalService/ListRecoveryDetails`,
    LIST_SECURE_CONTACT: `/services/squareup.multipass.external.MultipassExternalService/ListSecureContact`,
    LIST_TWO_FACTOR: `/services/squareup.multipass.external.MultipassExternalService/ListTwoFactor`,
    LIST_TWO_FACTOR_REQUIREMENTS: `/services/squareup.multipass.external.MultipassExternalService/ListTwoFactorRequirements`,
    LOGOUT_ALL: `/services/squareup.multipass.external.MultipassExternalService/LogoutAll`,
    MANAGE_PHONE_DETAIL: `/services/squareup.multipass.external.MultipassExternalService/ManagePhoneDetail`,
    REGISTER_PASSKEY: `/services/squareup.multipass.frontend.AccountService/RegisterPasskey`,
    REMOVE_TWO_FACTOR: `/services/squareup.multipass.external.MultipassExternalService/RemoveTwoFactor`,
    RESET_PASSWORD_CHANGE_PASSWORD: `/services/squareup.multipass.external.MultipassExternalService/ResetPasswordChangePassword`,
    RESET_PASSWORD_SEND_CODE: `/services/squareup.multipass.external.MultipassExternalService/ResetPasswordSendCode`,
    SEND_VERIFICATION_CODE: `/services/squareup.multipass.external.MultipassExternalService/SendVerificationCode`,
    SET_ACCOUNT_INFORMATION: `/services/squareup.multipass.frontend.AccountService/SetAccountInformation`,
    UPDATE_PASSKEY: `/services/squareup.multipass.external.MultipassExternalService/UpdatePasskey`,
    UPDATE_PERSON_TWO_FACTOR: `/services/squareup.multipass.external.MultipassExternalService/UpdatePersonTwoFactor`,
    UPDATE_SECURE_CONTACT: `/services/squareup.multipass.external.MultipassExternalService/UpdateSecureContact`,
    UPGRADE_SESSION_TWO_FACTOR: `/services/squareup.multipass.external.MultipassExternalService/UpgradeSessionTwoFactor`,
    UPGRADE_SESSION_MULTIPLE_FACTORS: `/services/squareup.multipass.external.MultipassExternalService/UpgradeSessionMultipleFactors`,
    VERIFY_RECOVERY_DETAIL: `/services/squareup.multipass.external.MultipassExternalService/VerifyRecoveryDetail`,
    VERIFY_SECURE_CONTACT: `/services/squareup.multipass.external.MultipassExternalService/VerifySecureContact`,
    LIST_LAUNCHPAD_ITEMS: `/services/squareup.multipass.external.MultipassExternalService/ListLaunchpadItems`,
    LIST_PASSKEYS: `/services/squareup.multipass.external.MultipassExternalService/ListPasskeys`
  },
  ERRORS: {
    UNAUTHORIZED: 'UNAUTHORIZED'
  }
});
let SquareEmberMultipassFEClientService = (_dec = service('ember-multipass-config'), _dec2 = service('ember-multipass-flag'), _dec3 = service('ember-multipass-cookie-utils'), _dec4 = service('ember-multipass-storage'), _class = class SquareEmberMultipassFEClientService extends Service {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "cookies", _descriptor, this);
    _initializerDefineProperty(this, "multipassConfig", _descriptor2, this);
    _initializerDefineProperty(this, "flags", _descriptor3, this);
    _initializerDefineProperty(this, "cookieUtils", _descriptor4, this);
    _initializerDefineProperty(this, "storage", _descriptor5, this);
    // Session state
    _initializerDefineProperty(this, "limited", _descriptor6, this);
    // Account Completion fields
    _initializerDefineProperty(this, "hasEmail", _descriptor7, this);
    _initializerDefineProperty(this, "hasPassword", _descriptor8, this);
    // Secure contact fields
    _initializerDefineProperty(this, "secureContactDetails", _descriptor9, this);
    // 2FA fields
    _initializerDefineProperty(this, "accountLockoutAt", _descriptor10, this);
    _initializerDefineProperty(this, "canUseActivationPhone", _descriptor11, this);
    _initializerDefineProperty(this, "canUseIdentityVerificationPhone", _descriptor12, this);
    _initializerDefineProperty(this, "canUseNewPhone", _descriptor13, this);
    _initializerDefineProperty(this, "canUseCustomerSuccess", _descriptor14, this);
    _initializerDefineProperty(this, "canUseSms", _descriptor15, this);
    _initializerDefineProperty(this, "canUseVoice", _descriptor16, this);
    _initializerDefineProperty(this, "canDisablePersonalRequirement", _descriptor17, this);
    _initializerDefineProperty(this, "googleAuthDetails", _descriptor18, this);
    _initializerDefineProperty(this, "recoveryDetails", _descriptor19, this);
    _initializerDefineProperty(this, "requiresTwoFactor", _descriptor20, this);
    _initializerDefineProperty(this, "trustedDevice", _descriptor21, this);
    _initializerDefineProperty(this, "twoFactorDefaults", _descriptor22, this);
    _initializerDefineProperty(this, "twoFactorDetails", _descriptor23, this);
    _initializerDefineProperty(this, "twoFactorProvidedTimestamp", _descriptor24, this);
    _initializerDefineProperty(this, "twoFactorPromoEnabled", _descriptor25, this);
    _initializerDefineProperty(this, "twoFactorPromoCohort", _descriptor26, this);
    _initializerDefineProperty(this, "mandatoryTwoFactorDetails", _descriptor27, this);
    _initializerDefineProperty(this, "twoFactorReasons", _descriptor28, this);
    _initializerDefineProperty(this, "merchantToken", _descriptor29, this);
    _initializerDefineProperty(this, "personToken", _descriptor30, this);
    _initializerDefineProperty(this, "accountInformation", _descriptor31, this);
    _initializerDefineProperty(this, "proofOfWorkNonce", _descriptor32, this);
    _initializerDefineProperty(this, "tmxSessionId", _descriptor33, this);
    _initializerDefineProperty(this, "passkeyAuthPublicKeyCredentialRequestOptions", _descriptor34, this);
    _initializerDefineProperty(this, "completeLoginObligations", _descriptor35, this);
    _initializerDefineProperty(this, "passkeys", _descriptor36, this);
    // Domain separation
    _defineProperty(this, "useAppSubdomain", false);
    this.cookieUtils.findAvtCookie();
    this.flags.loadAvtFlags();
  }
  get constants() {
    return CONFIG.CONSTANTS;
  }
  get bareDomains() {
    return CONFIG.BARE_DOMAIN;
  }
  get hasAccountLockoutAt() {
    return this.accountLockoutAt !== undefined;
  }
  get hasTwoFactorDetails() {
    return this.twoFactorDetails?.length > 0;
  }
  get hasEscalatedTwoFactorTimestamp() {
    return Object.values(CONFIG.CONSTANTS.TWO_FACTOR_ESCALATION_TIMESTAMP).includes(this.twoFactorProvidedTimestamp);
  }
  get isMandatoryTwoFactorCohort() {
    return String(this.twoFactorPromoCohort).toUpperCase() === CONFIG.CONSTANTS.TWO_FACTOR_PROMO_COHORTS.INCLUDED_MANDATORY;
  }
  get twoFactorPromoMandatory() {
    return this.twoFactorPromoEnabled && this.isMandatoryTwoFactorCohort;
  }
  get twoFactorRecoveryReason() {
    const twoFactorReasonsToRecoveryReasons = {
      [CONFIG.CONSTANTS.TWO_FACTOR_REASONS.DORMANT_RECOVERY]: CONFIG.CONSTANTS.RECOVERY_REASON.DORMANT_RECOVERY,
      [CONFIG.CONSTANTS.TWO_FACTOR_REASONS.MANDATORY]: CONFIG.CONSTANTS.RECOVERY_REASON.MANDATORY_2FA
    };
    return this.twoFactorReasons.reduce((prev, curr) => twoFactorReasonsToRecoveryReasons[curr] ?? prev, undefined);
  }
  get smsResetPhone() {
    return CONFIG.CONSTANTS.SMS_RESET_PHONE;
  }
  get smsTwoFactorDetails() {
    return this.twoFactorDetails?.filter(x => x.sms) || [];
  }
  get secureContactEligibleSmsTwoFactorDetails() {
    return this.smsTwoFactorDetails.filter(x => x.sms.eligible_for_secure_contact_detail_enrollment);
  }
  get hasCompleteLoginObligations() {
    return this.completeLoginObligations.length > 0;
  }
  get hasPre2faObligations() {
    return CONFIG.CONSTANTS.PRE_2FA_OBLIGATIONS.some(o => this.completeLoginObligations.includes(o));
  }
  get hasPost2faObligations() {
    return CONFIG.CONSTANTS.POST_2FA_OBLIGATIONS.some(o => this.completeLoginObligations.includes(o));
  }
  get pre2faObligation() {
    return CONFIG.CONSTANTS.PRE_2FA_OBLIGATIONS.find(o => this.completeLoginObligations.includes(o));
  }
  get post2faObligation() {
    return CONFIG.CONSTANTS.POST_2FA_OBLIGATIONS.find(o => this.completeLoginObligations.includes(o));
  }
  getApexBareUri() {
    switch (this.multipassConfig.environment) {
      case 'production':
        return CONFIG.BARE_URI.PRODUCTION;
      case 'staging':
        return CONFIG.BARE_URI.STAGING;
      case 'sandbox':
        return CONFIG.BARE_URI.SANDBOX;
      default:
        return '';
    }
  }
  getAppSubdomainBareUri() {
    return getAppSubdomainBareUri();
  }
  getBareUri() {
    return this.getApexBareUri();
  }
  getApiBaseUri(useBareUri = false) {
    const apiUriMetaTag = document.querySelector('meta[name=api-uri]');
    if (apiUriMetaTag && !useBareUri) {
      // ACCOUNTS-2749/ACCSEC-62 - Supports proxy logins for Restaurants/Dashboard teams.
      return apiUriMetaTag.getAttribute('content');
    }
    if (useBareUri) {
      return this.getBareUri();
    }
    if (this.multipassConfig.environment === 'production') {
      return CONFIG.BARE_APP_URI.PRODUCTION;
    } else if (this.multipassConfig.environment === 'staging') {
      return CONFIG.BARE_APP_URI.STAGING;
    } else if (this.multipassConfig.environment === 'sandbox') {
      return CONFIG.BARE_APP_URI.SANDBOX;
    }
    return '';
  }
  get isApexHostname() {
    if (this.multipassConfig.environment === 'development') {
      return false;
    }
    const hostname = window.location.hostname;
    switch (this.multipassConfig.environment) {
      case 'production':
        return hostname === CONFIG.BARE_DOMAIN.PRODUCTION;
      case 'staging':
        return hostname === CONFIG.BARE_DOMAIN.STAGING;
      case 'sandbox':
        return hostname === CONFIG.BARE_DOMAIN.SANDBOX;
      default:
        return true;
    }
  }
  get isAppHostname() {
    if (this.multipassConfig.environment === 'development') {
      return false;
    }
    const hostname = window.location.hostname;
    switch (this.multipassConfig.environment) {
      case 'production':
        return hostname === CONFIG.BARE_APP_DOMAIN.PRODUCTION;
      case 'staging':
        return hostname === CONFIG.BARE_APP_DOMAIN.STAGING || hostname.endsWith('.squareupstaging.com');
      case 'sandbox':
        return hostname === CONFIG.BARE_APP_DOMAIN.SANDBOX;
      default:
        return true;
    }
  }

  /**
   * Useful for determining whether 2FA enroll or upgrade can be bypassed or whether a time-based upgrade
   * should be performed after X amount of time.
   *
   * @param maxTwoFactorMinutes represented in milliseconds
   * @returns {boolean} whether twoFactorProvidedTimestamp is valid
   */
  hasValidTwoFactorProvidedTimestamp(maxTwoFactorMinutes = 2 ** 32) {
    // Falsey check will rule out undefined, null, 0, or empty strings
    if (!this.twoFactorProvidedTimestamp) {
      return false;
    }
    return (this.twoFactorProvidedTimestamp || 0) + maxTwoFactorMinutes > Date.now();
  }
  needsToEnrollTwoFactor(maxTwoFactorMinutes) {
    // If session already has valid two factor timestamp, bypass
    if (this.hasValidTwoFactorProvidedTimestamp(maxTwoFactorMinutes)) {
      return false;
    }
    return this.requiresTwoFactor && !this.hasTwoFactorDetails;
  }
  get needsToEnrollDormantRecovery() {
    if (this.completeLoginObligations.includes(CONFIG.CONSTANTS.LOGIN_OBLIGATIONS.DORMANT_RECOVERY)) {
      return true;
    }
    const recoveryReasons = [CONFIG.CONSTANTS.TWO_FACTOR_REASONS.DORMANT_RECOVERY, CONFIG.CONSTANTS.TWO_FACTOR_REASONS.MANDATORY];
    return this.requiresTwoFactor && recoveryReasons.some(reason => this.twoFactorReasons.includes(reason));
  }
  get needsRiskMagicLinkVerification() {
    return this.completeLoginObligations.includes(CONFIG.CONSTANTS.LOGIN_OBLIGATIONS.RISK_MAGIC_LINK);
  }
  needsToUpgradeTwoFactor(maxTwoFactorMinutes) {
    // If device is trusted, bypass
    if (this.trustedDevice === CONFIG.CONSTANTS.DEVICE_TRUSTED) {
      return false;
    }
    // If session already has valid two factor timestamp, bypass
    if (this.hasValidTwoFactorProvidedTimestamp(maxTwoFactorMinutes)) {
      return false;
    }

    // Lastly, require upgrade if 2FA is required, 2FA details exist, and session 2FA timestamp is not stale
    return this.requiresTwoFactor && this.hasTwoFactorDetails;
  }

  /**
   * =========================================================
   * ================ API CALLS ==============================
   * =========================================================
   */

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.UpdatePersonTwoFactorRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.UpdatePersonTwoFactorResponse Response Proto}
   */
  async enablePersonTwoFactorRequirement() {
    const data = {
      two_factor_state: 'REQUIRED',
      idempotence_key: this.createUUID()
    };
    const response = await this.httpPost(CONFIG.ENDPOINTS.UPDATE_PERSON_TWO_FACTOR, data);
    this.requiresTwoFactor = true;
    return response;
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.UpdatePersonTwoFactorRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.UpdatePersonTwoFactorResponse Response Proto}
   */
  async disablePersonTwoFactorRequirement() {
    const data = {
      two_factor_state: 'NONE',
      idempotence_key: this.createUUID()
    };
    const response = await this.httpPost(CONFIG.ENDPOINTS.UPDATE_PERSON_TWO_FACTOR, data);
    this.requiresTwoFactor = false;
    return response;
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.RemoveTwoFactorRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.RemoveTwoFactorResponse Response Proto}
   */
  async removeTwoFactor(data = {}) {
    return this.httpPost(CONFIG.ENDPOINTS.REMOVE_TWO_FACTOR, data);
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.BrowserHookRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.BrowserHookResponse Response Proto}
   */
  async browserHook(data = {}) {
    let url = CONFIG.ENDPOINTS.BROWSER_HOOK;
    if (data.app) {
      url = this.withQueryParams(url, {
        app: data.app
      });
    }
    data.idempotence_key = this.createUUID();
    const response = await this.httpPost(url, data, {
      bubbleError: false
    });
    this.requiresTwoFactor = response.requires_two_factor || false;
    this.proofOfWorkNonce = response.proof_of_work_nonce || undefined;
    this.limited = response.limited ?? false;
    return response;
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.ClaimAccountSendCodeRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.ClaimAccountSendCodeResponse Response Proto}
   */
  claimAccountSendCode(data = {}) {
    data.idempotence_key = this.createUUID();
    return this.httpPost(CONFIG.ENDPOINTS.CLAIM_ACCOUNT_SEND_CODE, data);
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.SetPasswordRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.SetPasswordResponse Response Proto}
   */
  claimAccountSetPassword(data = {}) {
    return this.httpPost(CONFIG.ENDPOINTS.CLAIM_ACCOUNT_SET_PASSWORD, data);
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.EnrollTwoFactorRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.EnrollTwoFactorResponse Response Proto}
   */
  async enrollTwoFactor(data = {}) {
    data.idempotence_key = this.createUUID();
    if (!data.locale) {
      data.locale = this.getCookieLocale();
    }
    const result = await this.httpPost(CONFIG.ENDPOINTS.ENROLL_TWO_FACTOR, data);
    if (result.complete) {
      this.requiresTwoFactor = true;
    }
    return result;
  }
  async enrollTwoFactorGoogleAuthenticator(locale = undefined) {
    const data = {
      two_factor_details: {
        googleauth: {}
      },
      locale: locale || this.getCookieLocale()
    };
    const json = await this.enrollTwoFactor(data);
    this.googleAuthDetails = json?.two_factor_details?.googleauth;
    return json;
  }
  enrollTwoFactorSms(phone, locale) {
    return this.enrollTwoFactorPhone(phone, CONFIG.CONSTANTS.PHONE_DELIVERY_METHODS.SMS, locale);
  }
  enrollTwoFactorVoice(phone, locale) {
    return this.enrollTwoFactorPhone(phone, CONFIG.CONSTANTS.PHONE_DELIVERY_METHODS.VOICE, locale);
  }
  enrollTwoFactorPhone(phone, delivery_method, locale = undefined) {
    const data = {
      two_factor_details: {
        sms: {
          phone,
          delivery_method
        }
      },
      locale: locale || this.getCookieLocale()
    };
    return this.enrollTwoFactor(data);
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.http.LoginRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.http.LoginResponse Response Proto}
   */
  async login(data = {}, {
    forceCaptcha = false,
    app = undefined
  } = {}) {
    data.idempotence_token = this.createUUID();
    let url = CONFIG.ENDPOINTS.LOGIN;
    const fingerprintData = this.getFingerprintData();
    if (forceCaptcha) {
      url += '?fc=1';
    }

    // TMX header
    const extraHeaders = {};
    if (this.tmxSessionId) {
      extraHeaders['x-tmx-session-id'] = this.tmxSessionId;
    }

    // Only route login request to bare URI if on proper squareup domain
    const useBareUri = Object.values(CONFIG.BARE_DOMAIN).some(x => document.location.hostname.endsWith(x));
    let isAbsoluteUrl = false;
    if (this.isAppHostname && this.flags.getValue(FlagNames.MULTIPASSUI_USE_APP_SUBDOMAIN_LOGIN)) {
      url = this.getAppSubdomainBareUri() + url;
      isAbsoluteUrl = true;
    }
    const response = await this.httpPost(url, {
      ...data,
      ...fingerprintData
    }, {
      app,
      useBareUri,
      extraHeaders,
      isAbsoluteUrl
    });
    this.accountLockoutAt = response.account_lockout_at;
    this.canUseSms = response.can_use_sms || false;
    this.canUseVoice = response.can_use_voice || false;
    this.requiresTwoFactor = response.requires_two_factor || false;
    this.trustedDevice = response.trusted_device;
    this.twoFactorPromoEnabled = response.two_factor_promo || false;
    this.twoFactorPromoCohort = response.two_factor_promo_cohort || undefined;
    this.mandatoryTwoFactorDetails.promptStartTimestamp = response.mandatory_2fa_cohort_start || undefined;
    this.mandatoryTwoFactorDetails.enforcementStartTimestamp = response.mandatory_2fa_enforcement_start || undefined;
    this.mandatoryTwoFactorDetails.revoked = response.mandatory_2fa_exception_revoked || undefined;
    this.hasEmail = response.has_email;
    this.hasPassword = response.has_password;
    this.limited = response.limited ?? false;
    if (this.limited) {
      await this.completeLogin();
    }
    return response;
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.CompleteLoginRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.CompleteLoginResponse Response Proto}
   */
  async completeLogin(loadObligationsState = true) {
    if (!this.flags.getValue(FlagNames.COMPLETE_LOGIN_ENABLED)) {
      return;
    }
    await this.httpPost(CONFIG.ENDPOINTS.COMPLETE_LOGIN, {});
    if (this.hasCompleteLoginObligations && loadObligationsState) {
      await this.preloadCompleteLoginDormantRecoveryObligationState();
    }
  }

  /**
   * Signs in using SMS TOTP code.
   *
   * @param {string} app
   * @param {string} phone
   * @param {string} verification_code
   * @param {object} options = {{boolean} forceCaptcha, {boolean} captcha_required, {string} captcha_response}
   * @returns {Promise} (object)
   */
  phoneLogin(app, phone, verification_code, {
    forceCaptcha = false,
    captcha_required,
    captcha_response = undefined,
    captcha_type = undefined
  } = {}) {
    if (captcha_required && !captcha_response) {
      throw new Error('CAPTCHA_REQUIRED');
    }
    const data = {
      app,
      phone,
      verification_code,
      captcha_response,
      captcha_type
    };
    return this.login(data, {
      forceCaptcha,
      app
    });
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.ResetPasswordChangePasswordRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.ResetPasswordChangePasswordResponse Response Proto}
   */
  async resetPasswordChangePassword(data = {}) {
    data.idempotence_key = this.createUUID();
    const response = await this.httpPost(CONFIG.ENDPOINTS.RESET_PASSWORD_CHANGE_PASSWORD, data);
    // determine if login obligations exist after password reset session is returned (state is loaded in set-new-success.js)
    await this.completeLogin(false);
    return response;
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.ResetPasswordSendCodeRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.ResetPasswordSendCodeResponse Response Proto}
   */
  resetPasswordSendCode(data = {}) {
    data.idempotence_key = this.createUUID();
    data.locale = data.locale || this.getCookieLocale();
    return this.httpPost(CONFIG.ENDPOINTS.RESET_PASSWORD_SEND_CODE, data);
  }

  /**
   * {@link https://prototype.sqprod.co/#/docs/squareup.multipass.http.StatusResponse Response Proto}
   */
  async status(app = undefined) {
    let url = CONFIG.ENDPOINTS.STATUS;
    if (app) {
      url = this.withQueryParams(url, {
        app
      });
    }
    const origin = this.isAppHostname ? this.getAppSubdomainBareUri() : this.getApexBareUri();
    const response = await this.httpGet(origin + url, {
      isAbsoluteUrl: true
    });
    this.merchantToken = response.merchant_token;
    this.personToken = response.person_token;
    this.twoFactorProvidedTimestamp = response.two_factor_provided_timestamp || null;
    this.requiresTwoFactor = response.requires_two_factor || false;
    this.canUseSms = response.can_use_sms || false;
    this.canUseVoice = response.can_use_voice || false;
    this.hasEmail = response.has_email;
    this.hasPassword = response.has_password;
    this.limited = response.limited ?? false;
    return response;
  }

  /**
   * {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.EnrollSecureContactRequest Request Proto}
   * {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.EnrollSecureContactResponse Response Proto}
   */
  async enrollSecureContact(data = {}) {
    const json = await this.httpPost(CONFIG.ENDPOINTS.ENROLL_SECURE_CONTACT, data);
    this.secureContactDetails = json.secure_contact_details;
    return json;
  }

  /**
   * {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.ListTwoFactorResponse Response Proto}
   */
  async listSecureContact() {
    const json = await this.httpPost(CONFIG.ENDPOINTS.LIST_SECURE_CONTACT, {});
    this.secureContactDetails = json.secure_contact_details;
    return json;
  }

  /**
   * {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.UpdateSecureContactRequest Request Proto}
   * {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.UpdateSecureContactResponse Response Proto}
   */
  async updateSecureContact(data = {}) {
    const json = await this.httpPost(CONFIG.ENDPOINTS.UPDATE_SECURE_CONTACT, data);
    this.secureContactDetails = json.secure_contact_details;
    return json;
  }

  /**
   * {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.VerifySecureContactRequest Request Proto}
   * {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.VerifySecureContactResponse Response Proto}
   */
  async verifySecureContact(data = {}) {
    return this.httpPost(CONFIG.ENDPOINTS.VERIFY_SECURE_CONTACT, data);
  }

  /**
   * {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.ListTwoFactorRequest Request Proto}
   * {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.ListTwoFactorResponse Response Proto}
   */
  async listTwoFactor(two_factor_verification_source = undefined) {
    const json = await this.httpPost(CONFIG.ENDPOINTS.LIST_TWO_FACTOR, {
      two_factor_verification_source
    });
    this.twoFactorDetails = json.two_factor_details;
    this.canDisablePersonalRequirement = json.can_disable_personal_requirement;
    this.twoFactorDefaults.trustedDeviceOptInDefault = json.trusted_device_opt_in_default;
    this.twoFactorDefaults.trustedDeviceTokenAgeIncrease = json.trusted_device_token_age_increase;
    return json;
  }

  /**
   * {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.ListTwoFactorRequirementsResponse Response Proto}
   */
  async listTwoFactorRequirements() {
    const json = await this.httpPost(CONFIG.ENDPOINTS.LIST_TWO_FACTOR_REQUIREMENTS, {});
    this.twoFactorReasons = json.requirement?.filter(r => r.two_factor_state === 'REQUIRED').map(r => r.two_factor_reason) ?? [];
    return json;
  }

  /**
   * {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.ListRecoveryDetailsResponse Response Proto}
   */
  async listRecoveryDetails({
    recoveryReason
  } = {}) {
    const reason = recoveryReason ?? this.twoFactorRecoveryReason ?? CONFIG.CONSTANTS.TWO_FACTOR_REASONS.DORMANT_RECOVERY;
    const json = await this.httpPost(CONFIG.ENDPOINTS.LIST_RECOVERY_DETAILS, {
      reason
    });
    this.recoveryDetails = json.recovery_details;
    this.canUseActivationPhone = json.can_use_activation_phone;
    this.canUseIdentityVerificationPhone = json.can_use_identity_verification_phone;
    this.canUseNewPhone = json.can_use_new_phone;
    this.canUseCustomerSuccess = json.can_use_customer_success;
  }

  /**
   * {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.VerifyRecoveryDetailRequest Request Proto}
   * {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.VerifyRecoveryDetailResponse Response Proto}
   */
  async verifyRecoveryDetail(data = {}) {
    const response = await this.httpPost(CONFIG.ENDPOINTS.VERIFY_RECOVERY_DETAIL, data);
    if (data.verification_code) {
      // attempt to obtain unlimited session after DORMANT_RECOVERY obligation complete
      await this.completeLogin();
    }
    return response;
  }
  verifyRecoveryDetailActivationPhone({
    phone,
    code,
    locale,
    reason,
    delivery_method
  }) {
    const data = {
      method: CONFIG.CONSTANTS.VERIFY_RECOVERY_DETAIL_METHODS.ACTIVATION_PHONE,
      phone,
      reason,
      locale: locale || this.getCookieLocale(),
      delivery_method
    };
    if (code) {
      data.verification_code = code;
    }
    return this.verifyRecoveryDetail(data);
  }
  verifyRecoveryDetailNewPhone({
    phone,
    code,
    locale,
    reason,
    delivery_method
  }) {
    const data = {
      method: CONFIG.CONSTANTS.VERIFY_RECOVERY_DETAIL_METHODS.NEW_PHONE,
      phone,
      reason,
      locale: locale || this.getCookieLocale(),
      delivery_method
    };
    if (code) {
      data.verification_code = code;
    }
    return this.verifyRecoveryDetail(data);
  }
  verifyRecoveryDetailIdentityVerificationPhone({
    phone,
    reason,
    locale
  }) {
    const data = {
      method: CONFIG.CONSTANTS.VERIFY_RECOVERY_DETAIL_METHODS.IDENTITY_VERIFICATION_PHONE,
      phone,
      reason,
      locale: locale || this.getCookieLocale()
    };
    return this.verifyRecoveryDetail(data);
  }

  /**
   * Post merchant selection to multipassfe
   * @param {string} merchant_token
   */
  postMerchantSelection(merchant_token) {
    return this.httpPost(CONFIG.ENDPOINTS.SELECT_MERCHANT, {
      merchant_token
    });
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.VerificationCodeRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.VerificationCodeResponse Response Proto}
   */
  sendVerificationCode(data = {}, {
    app
  } = {}) {
    data.idempotence_key = this.createUUID();
    return this.httpPost(CONFIG.ENDPOINTS.SEND_VERIFICATION_CODE, data, {
      app
    });
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.ListLaunchpadItemsRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.ListLaunchpadItemsResponse Response Proto}
   */
  listLaunchpad(data = {
    app: undefined,
    return_to: undefined,
    login_only_return_to: undefined
  }) {
    return this.httpPost(CONFIG.ENDPOINTS.LIST_LAUNCHPAD_ITEMS, data);
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.ListPasskeysRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.ListPasskeysResponse Response Proto}
   */
  async listPasskeys() {
    const response = await this.httpPost(CONFIG.ENDPOINTS.LIST_PASSKEYS, {});
    this.passkeys = response.passkeys ?? [];
    return response;
  }

  /**
   * Sends TOTP code to user using email method for the purpose of logging in.
   *
   * @param {string} app
   * @param {string} email
   * @param {string} returnTo
   * @param {string} loginOnlyReturnTo
   * @returns {Promise}
   */
  sendEmailLoginCode(app, email, returnTo = undefined, loginOnlyReturnTo = undefined) {
    const data = {
      app,
      email,
      reason: CONFIG.CONSTANTS.SEND_VERIFICATION_CODE_LOGIN,
      send_link: true,
      locale: this.getCookieLocale()
    };
    if (returnTo || loginOnlyReturnTo) {
      data.query_params = {};
      if (returnTo) {
        data.query_params.return_to = returnTo;
      }
      if (loginOnlyReturnTo) {
        data.query_params.login_only_return_to = loginOnlyReturnTo;
      }
    }
    return this.sendVerificationCode(data, {
      app
    });
  }
  async sendRiskMagicLink(email) {
    if (!email) {
      throw new Error('Email address is required to send risk magic link');
    }
    const result = await this.sendVerificationCode({
      reason: CONFIG.CONSTANTS.SEND_VERIFICATION_CODE_RISK_MAGIC_LINK,
      email,
      locale: this.getCookieLocale()
    });
    this.storage.setRiskMagicLinkSent();
    return result;
  }

  /**
   * Sends TOTP code to user using SMS method for the purpose of logging in.
   *
   * @param {string} app
   * @param {string} sms_phone
   * @returns {Promise}
   */
  sendSmsLoginCode(app, sms_phone) {
    return this.sendVerificationCode({
      app,
      reason: CONFIG.CONSTANTS.SEND_VERIFICATION_CODE_LOGIN,
      sms_phone,
      locale: this.getCookieLocale()
    }, {
      app
    });
  }

  /**
   * Sends TOTP code to user using SMS delivery method for the purpose of 2FA upgrading.
   *
   * @param {string} sms_phone
   * @param {object} options {@param {string} delivery_method, @param {string} locale, @param {string} app, @param {boolean} resend}
   * @returns {Promise}
   */
  sendSmsTwoFactorCode(sms_phone, options) {
    return this.sendPhoneTwoFactorCode(sms_phone, {
      delivery_method: CONFIG.CONSTANTS.PHONE_DELIVERY_METHODS.SMS,
      ...options
    });
  }

  /**
   * Sends TOTP code to user using Voice delivery method for the purpose of 2FA upgrading.
   *
   * @param {string} sms_phone
   * @param {object} options {@param {string} delivery_method, @param {string} locale, @param {string} app, @param {boolean} resend}
   * @returns {Promise}
   */
  sendVoiceTwoFactorCode(sms_phone, options) {
    return this.sendPhoneTwoFactorCode(sms_phone, {
      delivery_method: CONFIG.CONSTANTS.PHONE_DELIVERY_METHODS.VOICE,
      ...options
    });
  }

  /**
   * Sends TOTP code to user's phone with the specified delivery method, for the purpose of 2FA upgrading.
   *
   * @param {string} sms_phone
   * @param {object} options {@param {string} delivery_method, @param {string} locale, @param {string} app, @param {boolean} resend}
   * @returns {Promise}
   */
  sendPhoneTwoFactorCode(sms_phone, {
    delivery_method = undefined,
    locale = undefined,
    app = undefined,
    resend = false
  } = {}) {
    return this.sendVerificationCode({
      app,
      reason: CONFIG.CONSTANTS.SEND_VERIFICATION_CODE_TWO_FACTOR,
      sms_phone,
      delivery_method,
      locale: locale || this.getCookieLocale(),
      client_metadata: {
        client_resend_action: resend
      }
    }, app);
  }

  /**
   * Sends TOTP code to user's email, for the purpose of 2FA upgrading.
   *
   * @param {string} email
   * @param {object} options {@param {string} locale, @param {string} app, @param {boolean} resend}
   * @returns {Promise}
   */
  sendEmailTwoFactorCode(email, {
    locale = undefined,
    app = undefined,
    resend = false
  } = {}) {
    return this.sendVerificationCode({
      app,
      reason: CONFIG.CONSTANTS.SEND_VERIFICATION_CODE_TWO_FACTOR,
      email,
      locale: locale || this.getCookieLocale(),
      client_metadata: {
        client_resend_action: resend
      }
    }, app);
  }

  /**
   * Sends OTP code to user using EMAIL method for the purpose of SecureContact verification.
   *
   * @param {string} email
   * @param {object} options {@param {string} locale, @param {string} app}
   * @returns {Promise}
   */
  sendEmailSecureContactCode(email, {
    locale = undefined,
    app = undefined
  } = {}) {
    return this.sendVerificationCode({
      app,
      reason: CONFIG.CONSTANTS.SEND_VERIFICATION_CODE_SECURE_CONTACT,
      email,
      locale: locale || this.getCookieLocale()
    }, app);
  }

  /**
   * Sends OTP code to user using PHONE method for the purpose of SecureContact verification.
   *
   * @param {string} sms_phone
   * @param {object} options {@param {string} locale, @param {string} app}
   * @returns {Promise}
   */
  sendPhoneSecureContactCode(sms_phone, {
    locale = undefined,
    app = undefined
  } = {}) {
    return this.sendVerificationCode({
      app,
      reason: CONFIG.CONSTANTS.SEND_VERIFICATION_CODE_SECURE_CONTACT,
      sms_phone,
      locale: locale || this.getCookieLocale()
    }, app);
  }

  /**
   * Sends CTA link to user using EMAIL method for the purpose of alias verification.
   * @param {string} email
   * @param {string} locale
   * @param {string} app
   * @param {string} returnTo
   * @param {string} loginOnlyReturnTo
   * @returns {Promise<Response>}
   */
  sendAliasVerificationEmail({
    email,
    locale,
    app,
    returnTo,
    loginOnlyReturnTo
  }) {
    const data = {
      app,
      reason: CONFIG.CONSTANTS.SEND_VERIFICATION_CODE_VERIFY,
      email,
      send_link: true,
      locale: locale || this.getCookieLocale()
    };
    if (returnTo || loginOnlyReturnTo) {
      data.query_params = {};
      if (returnTo) {
        data.query_params.return_to = returnTo;
      }
      if (loginOnlyReturnTo) {
        data.query_params.login_only_return_to = loginOnlyReturnTo;
      }
    }
    return this.sendVerificationCode(data, app);
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.UpgradeSessionTwoFactorRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.UpgradeSessionTwoFactorResponse Response Proto}
   */
  upgradeSessionTwoFactor(data = {}) {
    return this.httpPost(CONFIG.ENDPOINTS.UPGRADE_SESSION_TWO_FACTOR, data);
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.UpgradeSessionMultipleFactorsRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.UpgradeSessionMultipleFactorsResponse Response Proto}
   */
  upgradeSessionMultipleFactors(data = {}) {
    return this.httpPost(CONFIG.ENDPOINTS.UPGRADE_SESSION_MULTIPLE_FACTORS, data);
  }

  /**
   * {@link https://prototype.sqprod.co/#/docs/squareup.multipass.frontend.ChangeAliasRequest Request Proto}
   * {@link https://prototype.sqprod.co/#/docs/squareup.multipass.frontend.ChangeAliasResponse Response Proto}
   */
  async changeAlias(data = {}) {
    data.idempotence_token = this.createUUID();
    const response = await this.httpPost(CONFIG.ENDPOINTS.CHANGE_ALIAS, data);
    if (response.sms_phone) {
      this.accountInformation.phone_number = response.sms_phone;
    }
    return response;
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.frontend.ChangeEmailRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.frontend.ChangeEmailResponse Response Proto}
   */
  changeEmail(data = {}) {
    return this.httpPost(CONFIG.ENDPOINTS.CHANGE_EMAIL, data);
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.service.CheckPasswordRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.service.CheckPasswordResponse Response Proto}
   */
  checkPassword(data = {}) {
    return this.httpPost(CONFIG.ENDPOINTS.CHECK_PASSWORD, data);
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.service.ChangePasswordRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.service.ChangePasswordResponse Response Proto}
   */
  changePassword(data = {}) {
    return this.httpPost(CONFIG.ENDPOINTS.CHANGE_PASSWORD, data);
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.service.CreateMandatoryTwoFactorExceptionRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.service.CreateMandatoryTwoFactorExceptionResponse Response Proto}
   */
  createMandatoryTwoFactorException(data = {}) {
    return this.httpPost(CONFIG.ENDPOINTS.CREATE_MANDATORY_TWO_FACTOR_EXCEPTION, data);
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.frontend.GetAccountInformationRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.frontend.GetAccountInformationResponse Response Proto}
   */
  async getAccountInformation() {
    const response = await this.httpPost(CONFIG.ENDPOINTS.GET_ACCOUNT_INFORMATION, {});
    this.accountInformation = response;
    this.passkeys = response.passkeys ?? [];
    return response;
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.frontend.SetAccountInformationRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.frontend.SetAccountInformationResponse Response Proto}
   */
  async setAccountInformation(data = {}) {
    const response = await this.httpPost(CONFIG.ENDPOINTS.SET_ACCOUNT_INFORMATION, data);
    await this.getAccountInformation();
    return response;
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.TwoFactorPromoCohortRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.TwoFactorPromoCohortResponse Response Proto}
   */
  async getTwoFactorPromoCohort() {
    const response = await this.httpPost(CONFIG.ENDPOINTS.GET_TWO_FACTOR_PROMO_COHORT, {});
    this.twoFactorPromoCohort = response.result;
    return response;
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.AdvancedEnrollTwoFactorSendLinkRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.AdvancedEnrollTwoFactorSendLinkResponse Response Proto}
   */
  advancedEnrollTwoFactorSendLink(data = {}) {
    return this.httpPost(CONFIG.ENDPOINTS.ADVANCED_ENROLL_TWO_FACTOR_SEND_LINK, {
      ...data,
      locale: data.locale || this.getCookieLocale()
    });
  }
  /**
  {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.GetPasskeyChallengeRequest Request Proto}
  {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.GetPasskeyChallengeResponse Response Proto}
  */
  async getPasskeyChallenge(data = {}) {
    const response = await this.httpPost(CONFIG.ENDPOINTS.GET_PASSKEY_CHALLENGE, data);
    const requestOptions = JSON.parse(response.public_key_credential_request_options);
    requestOptions.authentication_id = response.authentication_id;
    this.passkeyAuthPublicKeyCredentialRequestOptions = JSON.stringify(requestOptions);
    return response;
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.LogoutAllRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.LogoutAllResponse Response Proto}
   */
  logoutAll({
    exclude_current_session
  } = {}) {
    return this.httpPost(CONFIG.ENDPOINTS.LOGOUT_ALL, {
      exclude_current_session
    });
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.ManagePhoneDetailRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.ManagePhoneDetailResponse Response Proto}
  */
  async managePhoneDetail(data = {}) {
    return this.httpPost(CONFIG.ENDPOINTS.MANAGE_PHONE_DETAIL, data);
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.CheckLoginRequirementsRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.CheckLoginRequirementsResponse Response Proto}
  */
  async checkLoginRequirements({
    inferable,
    app,
    locale
  } = {}) {
    const data = {
      idempotence_key: this.createUUID(),
      inferable,
      app,
      locale: locale ?? this.getCookieLocale(),
      device_type: 'WEB'
    };
    const res = await this.httpPost(CONFIG.ENDPOINTS.CHECK_LOGIN_REQUIREMENTS, data);
    if (res.public_key_credential_request_options) {
      this.passkeyAuthPublicKeyCredentialRequestOptions = res.public_key_credential_request_options;
    }
    return res;
  }
  acceptInvitation(data) {
    return this.httpPost(CONFIG.ENDPOINTS.ACCEPT_INVITATION, data);
  }

  /**
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.InitiateInvitationRequest Request Proto}
   {@link https://prototype.sqprod.co/#/docs/squareup.multipass.external.InitiateInvitationResponse Response Proto}
   */
  initiateInvitation(data) {
    return this.httpPost(CONFIG.ENDPOINTS.INITIATE_INVITATION, data);
  }
  registerPasskey(data = {}, {
    createToken
  } = {
    createToken: false
  }) {
    if (createToken) {
      data.idempotence_token = this.createUUID();
    }
    return this.httpPost(CONFIG.ENDPOINTS.REGISTER_PASSKEY, data);
  }
  deregisterPasskey(data = {}) {
    data.idempotence_token = this.createUUID();
    return this.httpPost(CONFIG.ENDPOINTS.DEREGISTER_PASSKEY, data);
  }
  updatePasskey(data = {}) {
    return this.httpPost(CONFIG.ENDPOINTS.UPDATE_PASSKEY, data);
  }

  /**
   * =========================================================
   * ================ HELPER FUNCTIONS =======================
   * =========================================================
   */

  redirect(params = {}) {
    this.redirectToUrl(this.withQueryParams(CONFIG.ENDPOINTS.REDIRECT, params));
  }
  redirectToLogin() {
    this.redirectToUrl('/login', {
      return_to: window.location.pathname
    });
  }
  redirectToUrl(url = CONFIG.ENDPOINTS.REDIRECT, params = {}) {
    let redirectUrl = url;
    if (params) {
      redirectUrl = this.withQueryParams(redirectUrl, params);
    }
    if (window._redirectTo === undefined) {
      window.location.href = redirectUrl;
    } else {
      window._redirectTo(redirectUrl);
    }
  }

  /**
   * Replace old origin with the app domain origin
   * @param {string} url
   * @returns {string} replaced full URL
   */
  replaceApexOriginWithAppSubdomain(url) {
    return url.replace(this.getApexBareUri(), this.getAppSubdomainBareUri());
  }

  /**
   * @param {string} endpoint
   * @param {object} options
   * @returns {Promise<Response>} the response object wrapped inside a Promise
   */
  async httpGet(endpoint, {
    isAbsoluteUrl = false,
    bubbleError = true
  } = {}) {
    const url = isAbsoluteUrl ? endpoint : this.getApiBaseUri() + endpoint;
    const request = {
      method: 'get',
      credentials: 'include'
    };
    const response = await fetch(url, request);
    const json = await response.json();
    if (bubbleError) {
      if (json.error) {
        throw new Error(json.error);
      } else if (response.status > 299) {
        const errorCodes = json?.code || json?.errors?.map(error => error.code).join(', ');
        if (response.status === 401) {
          this.redirectToLogin();
          if (!errorCodes) {
            throw new Error(CONFIG.ERRORS.UNAUTHORIZED);
          }
        }
        throw new Error(errorCodes || JSON.stringify(json));
      }
    }
    return json;
  }

  /**
   * @param {string} endpoint
   * @param {object} data
   * @param {object} options
   * @returns {Promise<Response>} the response object wrapped inside a Promise
   */
  async httpPost(endpoint, data, {
    app = undefined,
    bubbleError = true,
    useBareUri = false,
    extraHeaders = {},
    isAbsoluteUrl = false
  } = {}) {
    const url = isAbsoluteUrl ? endpoint : this.getApiBaseUri(useBareUri) + endpoint;
    const headers = {
      'content-type': 'application/json',
      ...extraHeaders
    };
    const csrfToken = this.getCsrfToken(app);
    if (csrfToken) {
      headers['X-Csrf-Token'] = csrfToken;
    }
    const request = {
      method: 'post',
      body: JSON.stringify(data),
      credentials: 'include',
      headers
    };
    const response = await fetch(url, request);
    const json = await response.json();
    if (bubbleError) {
      if (json.error) {
        throw new Error(json.error);
      } else if (endpoint === CONFIG.ENDPOINTS.COMPLETE_LOGIN && response.status === 403 && json?.errors?.[0]?.obligations?.length) {
        // TODO: Remove endpoint check above and replace with envoy header check once API subdomains are adjusted to be identical (fetch() response headers cannot be read for CORS requests)
        this.completeLoginObligations = json.errors?.[0]?.obligations;
        return {};
      } else if (response.status > 299) {
        const errorCodes = json?.code || json?.errors?.map(error => error.code).join(', ');
        if (response.status === 401) {
          this.redirectToLogin();
          if (!errorCodes) {
            throw new Error(CONFIG.ERRORS.UNAUTHORIZED);
          }
        }
        throw new Error(errorCodes || JSON.stringify(json));
      }
    }
    return json;
  }
  getCsrfToken(app) {
    if (isEmpty(this.cookies)) {
      return null;
    } else if (!app) {
      return this.cookies.read('_js_csrf');
    }
    app = String(app).toUpperCase();
    switch (app) {
      case 'LOYALTY':
      case 'APPOINTMENTS':
        return this.cookies.read('_js_csrf[buyer]');
      case 'CAPITAL_CONSUMER':
        return this.cookies.read('_js_csrf[capital-consumer]');
      case 'CAPITAL_PARTNERSHIPS':
        return this.cookies.read('_js_csrf[capital-partnerships]');
      case 'BUYER_PORTAL':
        return this.cookies.read('_js_csrf[square-buyer]');
      case 'SQUARE_PROJECTS':
        return this.cookies.read('_js_csrf[square-buyer]');
      case 'SQUARE_LOCAL':
        return this.cookies.read('_js_csrf[square-buyer]');
      case 'DEVELOPER':
      default:
        return this.cookies.read('_js_csrf');
    }
  }

  /**
   * Fingerprint2 definition provided in MultipassUI's vendor/ dir, otherwise must be provided.
   */
  getFingerprintData() {
    const data = {};
    if (window.fingerprintHash) {
      data.browser_fingerprint = window.fingerprintHash;
    }
    if (window.fingerprintComponentsJson) {
      data.browser_fingerprint_components_json = window.fingerprintComponentsJson;
    }
    if (window.fingerprintSansHash) {
      data.browser_fingerprint_sans = window.fingerprintSansHash;
    }
    if (window.fingerprintSansComponentsJson) {
      data.browser_fingerprint_sans_components_json = window.fingerprintSansComponentsJson;
    }
    return data;
  }

  /*
   * Take url string and params object and constructs URL string with query params.
   *
   * @param {string} url
   * @param {object} params
   * @returns {string}
   */
  withQueryParams(url, params = {}) {
    let components = [];
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value.length > 0) {
        components.push(`${key}=${encodeURIComponent(value)}`);
      }
    }
    if (components.length === 0) {
      return url;
    }
    return `${url}?${components.join('&')}`;
  }
  createUUID() {
    return createUUID();
  }
  getCookieLocale() {
    return this.cookies.exists(CONFIG.CONSTANTS.NOTIFICATION_LOCALE_COOKIE_NAME) ? this.cookies.read(CONFIG.CONSTANTS.NOTIFICATION_LOCALE_COOKIE_NAME) : undefined;
  }
  generateTmxSessionId() {
    this.tmxSessionId = this.createUUID();
  }
  async preloadCompleteLoginDormantRecoveryObligationState() {
    if (this.completeLoginObligations.includes(CONFIG.CONSTANTS.LOGIN_OBLIGATIONS.DORMANT_RECOVERY)) {
      await Promise.all([this.listRecoveryDetails(), this.listTwoFactorRequirements()]);
    }
  }
  getEnvironment() {
    const {
      isDevelopment,
      isStaging,
      isProduction,
      isTesting
    } = environment();
    if (isTesting) return 'testing';
    if (isDevelopment) return 'development';
    if (isStaging) return 'staging';
    if (isProduction) return 'production';
    return '';
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "cookies", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "multipassConfig", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "flags", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "cookieUtils", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "storage", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "limited", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "hasEmail", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "hasPassword", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "secureContactDetails", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "accountLockoutAt", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "canUseActivationPhone", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "canUseIdentityVerificationPhone", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "canUseNewPhone", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "canUseCustomerSuccess", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "canUseSms", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "canUseVoice", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "canDisablePersonalRequirement", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "googleAuthDetails", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      account_name: null,
      authenticator_key_base32: null,
      authenticator_key_uri: null
    };
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "recoveryDetails", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "requiresTwoFactor", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "trustedDevice", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "twoFactorDefaults", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      trustedDeviceOptInDefault: false,
      trustedDeviceTokenAgeIncrease: false
    };
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "twoFactorDetails", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "twoFactorProvidedTimestamp", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "twoFactorPromoEnabled", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "twoFactorPromoCohort", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "mandatoryTwoFactorDetails", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      promptStartTimestamp: undefined,
      enforcementStartTimestamp: undefined,
      revoked: false
    };
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "twoFactorReasons", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "merchantToken", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "personToken", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "accountInformation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "proofOfWorkNonce", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "tmxSessionId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "passkeyAuthPublicKeyCredentialRequestOptions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "completeLoginObligations", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "passkeys", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _class);
export { SquareEmberMultipassFEClientService as default };
export const getAppSubdomainBareUri = () => {
  const {
    isStaging,
    isSandbox,
    isProduction
  } = environment();
  if (isProduction) {
    return CONFIG.BARE_APP_URI.PRODUCTION;
  }
  if (isSandbox) {
    return CONFIG.BARE_APP_URI.SANDBOX;
  }
  if (isStaging) {
    return CONFIG.BARE_APP_URI.STAGING;
  }
  return '';
};